import { createFileRoute, Navigate } from '@tanstack/react-router';

import { ShiftConfirmationAutoReplyCard } from '@apps/web/components/settings/shift_confirmation_auto_reply_card';
import { ShiftConfirmationMessagesCard } from '@apps/web/components/settings/shift_confirmation_messages_card';
import { ShiftConfirmationNoResponseWaitCard } from '@apps/web/components/settings/shift_confirmation_no_response_wait_card';
import { ShiftConfirmationRecurringSuppressionToggle } from '@apps/web/components/settings/shift_confirmation_recurring_suppression_toggle';
import { ShiftConfirmationScheduleSection } from '@apps/web/components/settings/shift_confirmation_schedule_section';
import {
    SettingsPageSection,
    SettingsPageSections,
    SettingsPageShell,
    useSettingsGates,
} from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/shift-confirmations')({
    component: ShiftConfirmationsPage,
});

function ShiftConfirmationsPage() {
    const { organizationId, gates } = useSettingsGates();
    if (!gates.canManageOrgSettings) {
        return <Navigate to="/settings" replace={true} />;
    }
    if (organizationId === null) {
        return null;
    }

    return (
        <SettingsPageShell
            title="Shift confirmation"
            description="Manage shift confirmation timing, scheduling, and caregiver-facing message templates."
        >
            <SettingsPageSections>
                <ShiftConfirmationScheduleSection
                    organizationId={organizationId}
                    variant="embedded"
                />
                <SettingsPageSection title="Recurring placements">
                    <ShiftConfirmationRecurringSuppressionToggle
                        organizationId={organizationId}
                    />
                </SettingsPageSection>
                <SettingsPageSection
                    title="No-response alerts"
                    description="How long Phoebe waits for a caregiver to answer the final follow-up before telling the office there was no response."
                >
                    <ShiftConfirmationNoResponseWaitCard
                        organizationId={organizationId}
                    />
                </SettingsPageSection>
                <SettingsPageSection
                    title="Auto-reply settings"
                    description="Choose which caregiver replies Phoebe can send without manual review."
                >
                    <ShiftConfirmationAutoReplyCard
                        organizationId={organizationId}
                    />
                </SettingsPageSection>
                <SettingsPageSection
                    title="Confirmation templates"
                    description="Edit caregiver-facing shift confirmation templates and preview their dynamic details."
                >
                    <ShiftConfirmationMessagesCard
                        organizationId={organizationId}
                    />
                </SettingsPageSection>
            </SettingsPageSections>
        </SettingsPageShell>
    );
}
